import React from "react";
import Grid from "@material-ui/core/Grid";
import Box from "@material-ui/core/Box";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import Footer from "@components/Homepage/Footer";
import PublicPage from "@components/PublicPage";
import { useTranslation } from "react-i18next";
import DefaultMetadata from "@components/DefaultMetadata";
import HubSpotForm from "@components/HubSpotForm";


const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    justifyContent: "center",
    marginTop: theme.spacing(2),
    // height: "93vh",
  },
  box: {
    width: "700px",
    // position: "absolute",
    // top: "15%",
    alignContent: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minHeight: "75vh",
  },
  form: {
    width: "100%",
    marginTop: theme.spacing(2),
  },
  typography: {
    marginTop: "50px",
    textAlign: "center",
  },
  submit: {
    width: "30%",
    marginTop: theme.spacing(3),
  },
  spinner: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
}));

function Handler() {
  const classes = useStyles();
  const { t, i18n } = useTranslation();

  return (
    <PublicPage>
      <DefaultMetadata title="EV Loader | Επικοινωνία" />

      <Grid container component="main" className={classes.root}>
        <Box className={classes.box}>
          <Typography component="h1" variant="h2" color="primary">
            {t("Επικοινωνία")}
          </Typography>
          <HubSpotForm
            formId={
              i18n.language === "el"
                ? "b4099ff2-38ab-44e3-bacf-9baf73f75445"
                : "eddbcc43-2c1e-4688-bb6b-e38d5cd9dd7c"
            }
          />
          {/* formId="eddbcc43-2c1e-4688-bb6b-e38d5cd9dd7c"/> */}
        </Box>
        <Footer />
      </Grid>
    </PublicPage>
  );
}

export default Handler;
